import React from 'react';

interface FormInputProps {
  label: string;
  value: string | number;
  onChange: (val: string) => void;
  type?: string;
  placeholder?: string;
  required?: boolean;
  mono?: boolean;
  min?: string;
  max?: string;
  maxLength?: number;
  pattern?: string;
  inputMode?: React.HTMLAttributes<HTMLInputElement>['inputMode'];
  autoCapitalize?: React.HTMLAttributes<HTMLInputElement>['autoCapitalize'];
  error?: string | null;
  onBlur?: () => void;
  disabled?: boolean;
  readOnly?: boolean;
}

export function FormInput({
  label,
  value,
  onChange,
  type = 'text',
  placeholder,
  required,
  mono,
  min,
  max,
  maxLength,
  pattern,
  inputMode,
  autoCapitalize,
  error,
  onBlur,
  disabled,
  readOnly,
}: FormInputProps) {
  const hasError = error && error.trim() !== '';

  return (
    <label className="block mb-2">
      <span className="block mb-1.5 text-base font-semibold text-gray-600">
        {label}
        {required && <span className="text-danger-500 ml-1">*</span>}
      </span>
      <input
        type={type}
        value={value}
        onChange={e => onChange(e.target.value)}
        onBlur={onBlur}
        placeholder={placeholder}
        min={min}
        max={max}
        maxLength={maxLength}
        pattern={pattern}
        inputMode={inputMode}
        autoCapitalize={autoCapitalize}
        disabled={disabled}
        readOnly={readOnly}
        className={`w-full px-3 py-2.5 border rounded-lg text-gray-900 text-lg outline-none transition-[border-color,box-shadow]
          ${disabled || readOnly ? 'bg-gray-100 cursor-not-allowed' : 'bg-white'}
          ${hasError
            ? 'border-danger-500 focus:border-danger-500 focus:ring-3 focus:ring-danger-500/10'
            : 'border-gray-300 focus:border-primary-500 focus:ring-3 focus:ring-primary-500/10'
          }
          ${mono ? 'font-mono' : ''}`}
      />
    </label>
  );
}
